import { InjectionToken } from '@angular/core'
import { IEnvironment } from './model/environment.model'
import { ErrorHandlingConfig } from './model/error-handling-config-model'

export enum COLLECTIONS {
  SELLER_APPLICATION = 'seller_application/',
}

export enum SEARCH_INDICES {
  PRODUCT_ITEM = 'product_item',
  PRODUCT_ITEM_PRICE_ASC = 'product_item_price_asc',
  PRODUCT_ITEM_PRICE_DESC = 'product_item_price_desc',
}

export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')

export const NOTIFICATION_DROPDOWN_COUNT = 5
export const CONVERSATION_DROPDOWN_COUNT = 5

export const ADMINISTRATOR_ROLE = 'Administrator'
export const CONSUMER_ROLE = 'Consumer'

export const SELLER_COMMISSION_FEE = 3.5

export const NOT_FOUND_ROUTE = '/home/404'

export enum InputsContext {
  Name = 'name',
  Description = 'description',
  LargeText = 'largeText',
}

export const INPUTS_MAXLENGTH_BY_CONTEXT: { [key in InputsContext]: number } = {
  name: 100,
  description: 200,
  largeText: 2000,
}

export const ERROR_HANDLING = new InjectionToken<ErrorHandlingConfig>('error_handling')
